/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// 관리자 페이지 routes
// 로그인 페이지
import LoginPage from 'views/admin/LoginPage/LoginPage';                // 관리자 로그인 화면
// 메인 대시보드
import Dashboard from 'views/admin/Dashboard/Dashboard';                // 홈(대시보드)
// 환경 설정
import BasicConfig from 'views/admin/Config/BasicConfig/Index';         // 기본 환경 설정
import MetaTagConfig from 'views/admin/Config/MetaTagConfig/Index';     // metatag 설정
// 페이지 설정
import Popup from 'views/admin/Page/Popup/Popup';                       // 팝업 관리
import CreatePopup from 'views/admin/Page/Popup/CreatePopup';           // 팝업 추가
import EditPopup from 'views/admin/Page/Popup/EditPopup';               // 팝업 수정
import Banner from 'views/admin/Page/Banner/Banner';                    // 배너 관리
import CreateBanner from 'views/admin/Page/Banner/CreateBanner';        // 배너 추가
import EditBanner from 'views/admin/Page/Banner/EditBanner';            // 배너 수정
// 게시판 설정
import QnAList from 'views/admin/Board/QnA/Index';                      // QnA 관리
import ReservationList from 'views/admin/Board/Reservation/Index';      // 예약 관리
// 회원 설정
import GroupList from 'views/admin/Member/Groups/GroupList';            // 그룹 관리
import MemberList from 'views/admin/Member/Members/MemberList';         // 회원 관리
import CreateMember from 'views/admin/Member/Members/CreateMember';     // 회원 추가
import EditMember from 'views/admin/Member/Members/EditMember';         // 회원 수정
import LoginLogList from 'views/admin/Member/LoginLogs/LoginLogList';   // 로그인 내역 관리
// ---------------------------------------------------------------------------------------------------
// 사용자 페이지 routes
import Main from 'views/pages/Main';  // 메인 페이지

const authLayoutRoute = '/auth';
const adminLayoutRoute = '/admin';
const publicLayoutRoute = '/';

const routes = [
  {
    path: '/home',
    name: '대시보드',
    icon: '',
    component: Dashboard,
    layout: adminLayoutRoute,
  },
  {
    collapse: true,
    name: '환경 설정',
    icon: 'ni ni-settings-gear-65 text-purple',
    state: 'configsCollapse',
    views: [
      {
        path: '/configs/basic',
        name: '기본 환경 설정',
        miniName: '기본',
        component: BasicConfig,
        layout: adminLayoutRoute,
      },
      {
        path: '/configs/metatag',
        name: '메타태그 설정',
        miniName: 'meta',
        component: MetaTagConfig,
        layout: adminLayoutRoute,
      },
    ],
  },
  {
    collapse: true,
    name: '페이지 설정',
    icon: 'ni ni-album-2 text-purple',
    state: 'pagesCollapse',
    views: [
      {
        path: '/pages/popup/list',
        name: '팝업 관리',
        miniName: '팝업',
        component: Popup,
        layout: adminLayoutRoute,
      },
      {
        path: '/pages/banner/list',
        name: '배너 관리',
        miniName: '배너',
        component: Banner,
        layout: adminLayoutRoute,
      },
    ],
  },
  {
    path: '/pages/popup/create',
    name: '팝업 추가',
    icon: '',
    component: CreatePopup,
    layout: adminLayoutRoute,
  },
  {
    path: '/pages/popup/edit/:id',
    name: '팝업 수정',
    icon: '',
    component: EditPopup,
    layout: adminLayoutRoute,
  },
  {
    path: '/pages/banner/create',
    name: '배너 추가',
    icon: '',
    component: CreateBanner,
    layout: adminLayoutRoute,
  },
  {
    path: '/pages/banner/edit/:id',
    name: '배너 수정',
    icon: '',
    component: EditBanner,
    layout: adminLayoutRoute,
  },
  {
    collapse: true,
    name: '예약 및 문의',
    icon: 'ni ni-collection text-purple',
    state: 'boardsCollapse',
    views: [
      {
        path: '/boards/reservation',
        name: '예약 관리',
        miniName: '예약',
        component: ReservationList,
        layout: adminLayoutRoute,
      },
      {
        path: '/boards/qna',
        name: '문의 관리',
        miniName: '문의',
        component: QnAList,
        layout: adminLayoutRoute,
      },
    ],
  },
  {
    collapse: true,
    name: '회원 설정',
    icon: 'ni ni-single-02 text-purple',
    state: 'membersCollapse',
    views: [
      {
        invisible: true,
        path: '/members/group',
        name: '그룹 관리',
        miniName: '그룹',
        component: GroupList,
        layout: adminLayoutRoute,
      },
      {
        path: '/members/member',
        name: '회원 관리',
        miniName: '회원',
        component: MemberList,
        layout: adminLayoutRoute,
      },
      {
        path: '/members/login-logs',
        name: '로그인 내역',
        miniName: '로그',
        component: LoginLogList,
        layout: adminLayoutRoute,
      },
    ],
  },
  {
    path: '/members/edit/:id',
    name: '회원 정보 수정',
    icon: '',
    component: EditMember,
    layout: adminLayoutRoute,
  },
  {
    path: '/members/create',
    name: '회원 추가',
    icon: '',
    component: CreateMember,
    layout: adminLayoutRoute,
  },
  {
    path: '/login',
    component: LoginPage,
    layout: authLayoutRoute,
  },
  {
    path: '',
    component: Main,
    layout: publicLayoutRoute,
  },
];

export default routes;
